module.exports = __webpack_public_path__ + "static/media/appleid_button@2x.a6e9bd62.png";